<template>
		<modal
			size="medium"
			@close="close">
			<template slot="header">
				<span>{{ $t('Stream Output Resolution') }}</span>
			</template>
			<template slot="body">
				<div class="is-loading large mt-2" v-if="isGettingDisplay">
				</div>
				<form @submit.prevent="save" v-if="!isGettingDisplay">
					<!-- Height -->
					<div class="form-group">
						<label>{{ $t('Height') }}</label>
						<input
							type="number"
							name="height"
							class="form-control"
							v-model="height"
						/>
					</div>
					<!-- Width -->
					<div class="form-group">
						<label>{{ $t('Width') }}</label>
						<input
							type="number"
							name="width"
							class="form-control"
							v-model="width"
						/>
					</div>
					<!-- Bitrate -->
					<div class="form-group">
						<label>{{ $t('Bitrate') }}</label>
						<input
							type="number"
							name="bitrate"
							class="form-control"
							v-model="bitrate"
						/>
					</div>
					<!-- Framerate -->
					<div class="form-group">
						<label>{{ $t('Framerate') }}</label>
						<input
							type="number"
							name="framerate"
							class="form-control"
							v-model="framerate"
						/>
					</div>
				</form>
			</template>
			<template slot="footer">
				<div class="w-100 flex-center">
					<button
						v-if="!isGettingDisplay"
						class="btn btn-primary"
						:class="{ 'is-loading': isSaving }"
						@click="save()">
						{{ $t('Update') }}
					</button>
					<button
						class="btn btn-default"
						@click="close">
						{{ $t('Cancel') }}
					</button>
				</div>
			</template>
		</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import { getAxiosErrorMessage } from '@/lib/helper';
import lightstreamsApi from '@/api/lightstream';

export default {
	name: 'LayoutLightstreamForm',
	props: {
		data: {
			type: Object,
		},
	},
	components: {
		Modal,
	},
	data() {
		return {
			framerate: 30,
			bitrate: 3000,
			width: 1920,
			height: 1080,
			isSaving: false,
			isGettingDisplay: false,
		};
	},
	methods: {
		save() {
			this.isSaving = true;
			const params = this.params;
			const callback = (response) => {
				// const item = response.data;
				const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Layout',
					text: message,
				});
				this.isSaving = false;
				this.close();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Layout',
					text: message,
				});
				this.isSaving = false;
			};
			// eslint-disable-next-line
			const display_id = this.data && this.data.lightstream && this.data.lightstream.display_id ? this.data.lightstream.display_id : 0;
			if (this.data) {
				lightstreamsApi.updateLayout(display_id, params, callback, errorCallback);
			}
		},
		close() {
			this.$emit('close');
		},
		initData() {
			this.reset();
			if (this.data) {
				this.setData(this.data);
			}
		},
		reset() {
			this.framerate = 0;
			this.bitrate = 0;
			this.width = 0;
			this.height = 0;
		},
		setData() {
			this.isGettingDisplay = true;
			const callback = (response) => {
				const item = response.data;
				this.bitrate = item.layout.bitrate;
				this.framerate = item.layout.framerate;
				this.width = item.layout.width;
				this.height = item.layout.height;
				this.isGettingDisplay = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Layout',
					text: message,
				});
				this.isGettingDisplay = false;
			};
			if (this.data) {
				lightstreamsApi.get(this.data.id, callback, errorCallback);
			}
		},
	},
	computed: {
		params() {
			const framerate = parseInt(this.framerate);
			const width = parseInt(this.width);
			const height = parseInt(this.height);
			const bitrate = parseInt(this.bitrate);
			const params = {
				framerate,
				width,
				height,
				bitrate,
			};
			return params;
		},
	},
	created() {
		this.initData();
	},
	watch: {
	},
};
</script>
